export const analyticsService = {
  trackEvent(eventName: string, properties?: Record<string, any>) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, properties);
    }
  },

  trackPageView(path: string) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', import.meta.env.VITE_GA_MEASUREMENT_ID, {
        page_path: path,
      });
    }
  },

  trackDownload(fileName: string) {
    this.trackEvent('download', {
      file_name: fileName,
      event_category: 'engagement',
    });
  },

  trackSignup(method: string) {
    this.trackEvent('sign_up', {
      method,
      event_category: 'engagement',
    });
  },

  trackContact(method: string) {
    this.trackEvent('contact', {
      method,
      event_category: 'engagement',
    });
  },

  trackPurchase(value: number, currency: string = 'EUR') {
    this.trackEvent('purchase', {
      value,
      currency,
      event_category: 'ecommerce',
    });
  },

  trackAuth(method: string) {
    this.trackEvent('login', {
      method,
      event_category: 'engagement',
    });
  },
};

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}